import {cva} from 'class-variance-authority'

/**
 * Toast / Snackbar content bar (v3, MUI-aligned). One axis: `severity`.
 *
 * Fills are the snackbar/alert component tokens from the Figma "Snackbar/Toast"
 * frame. `default`/`info`/`error` map cleanly onto the semantic palette
 * (`secondary` `#0D1F21` / `info` `#00BACC` / `error` `#D00019`); `success` uses
 * the alert-specific component token `#65d237` (the same value `Alert` inlines for
 * filled-success) which differs from the global `success` token (`#7ED957`), so
 * it is inlined here.
 */
export const ToastContentVariants = cva(
  'pointer-events-auto flex min-w-[256px] items-center justify-between gap-2 rounded-[4px] px-4 py-1.5 text-white shadow-elevation-3',
  {
    variants: {
      severity: {
        default: 'bg-secondary',
        info: 'bg-info',
        success: 'bg-[#65d237]',
        error: 'bg-error',
      },
    },
    defaultVariants: {
      severity: 'default',
    },
  },
)
